import { useQuery } from "react-query";
import linkboardApi from "api-generate-types/src/api/linkboard-api";
import { getCountries } from "shared-services/src/services/location";
import { getFacetsCategories } from "shared-services/src/services/facets";
import { FacetCategory, IGetFacetsResponse } from "shared-types/src/Facets";
import { useErrorBoundary } from "component-library/src/components/Organisms/providers/ErrorBoundaryProvider";

export const ROLE_PREFERENCES_FACETS_QUERY_KEY = "rolePreferencesFacets";

export const ROLE_PREFERENCES_SETTINGS_QUERY_KEY = "rolePreferencesJobSettings";

export const ROLE_PREFERENCES_COUNTRIES_QUERY_KEY = "rolePreferencesCountries";

export function useRolePreferencesData() {
  const captureError = useErrorBoundary();

  const {
    data: facets = [],
    isLoading: isFacetsLoading,
    isError: isFacetsError,
  } = useQuery<IGetFacetsResponse>(
    ROLE_PREFERENCES_FACETS_QUERY_KEY,
    async () => {
      const { data } = await getFacetsCategories([
        FacetCategory.Gender,
        FacetCategory.Disability,
        FacetCategory.Appearance,
        FacetCategory.ContractType,
        FacetCategory.ProductionType,
      ]);

      return data;
    },
    {
      onError: captureError,
    }
  );

  const {
    data: settingsData,
    isLoading: isSettingsLoading,
    isError: isSettingsError,
  } = useQuery(
    ROLE_PREFERENCES_SETTINGS_QUERY_KEY,
    async () => {
      const { data } = await linkboardApi.linkboard.jobSettingsGet();

      return data;
    },
    {
      onError: captureError,
    }
  );

  const {
    data: countries,
    isLoading: isCountriesLoading,
    isError: isCountriesError,
  } = useQuery(
    ROLE_PREFERENCES_COUNTRIES_QUERY_KEY,
    async () => {
      const { data } = await getCountries();

      return data;
    },
    {
      onError: captureError,
    }
  );

  return {
    facets,
    settingsData,
    countries,
    isLoading: isFacetsLoading || isSettingsLoading || isCountriesLoading,
    isError: isFacetsError || isSettingsError || isCountriesError,
  };
}
